import React from 'react';
import { Link } from 'react-router-dom';
import { Item } from '../../types/mostPopularType';
import { SearchItem } from '../../types/searchType';
import './_card.scss';

type CardProps = {
  onClick: (e: React.SyntheticEvent) => void;
  card: Item | SearchItem;
};

const Card: React.FC<CardProps> = (props) => {
  const { card, onClick } = props;
  let title = card.snippet.title;
  let description = card.snippet.description;
  const thumbnail = card.snippet.thumbnails.high.url;
  const id = card.id;

  if (title.length > 54) title = title.slice(0, 55) + '...';
  if (description.length > 99) description = description.slice(0, 99) + '...';

  return (
    <div className="card" data-id={id} onClick={onClick}>
      <div className="card__img">
        <img src={thumbnail} alt={title} />
      </div>
      <div className="card__info">
        <h3 className="card__title">{title}</h3>
        <p className="card__description">{description}</p>
      </div>
      <div className="card__buttons">
        <div className="card__button btn" data-id={id} onClick={onClick}>
          Open Modal
        </div>
        <Link to={`/video/${id}`}>
          <div className="card__button btn " data-id="detail-button">
            Open Detail
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Card;
